import { render } from "./EvangelioList.vue?vue&type=template&id=519d4003&scoped=true"
import script from "./EvangelioList.vue?vue&type=script&lang=js"
export * from "./EvangelioList.vue?vue&type=script&lang=js"

import "./EvangelioList.vue?vue&type=style&index=0&id=519d4003&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519d4003"]])

export default __exports__